export type TrendItem = {
  id: number;
  title: string;
  tag: string;
  category: string;
  shares: string;
  heat: number;
  time: string;
  hot?: boolean;
};

export const hotTrends: TrendItem[] = [
  { id: 1, title: "开学季·宿舍爆改挑战霸榜，00后脑洞集体出圈", tag: "出圈合集", category: "高校热点", shares: "128万+", heat: 98, time: "2小时前", hot: true },
  { id: 2, title: "「村咖」火了，县城咖啡店排队三小时只为一杯", tag: "疯传事件", category: "生活消费", shares: "96万+", heat: 93, time: "5小时前", hot: true },
  { id: 3, title: "图书馆占座「保卫战」，网友神回复金句集锦", tag: "热梗速递", category: "高校热点", shares: "71万+", heat: 88, time: "8小时前" },
  { id: 4, title: "「反内卷办公室」梗图刷屏，打工人集体共鸣", tag: "刷屏梗", category: "职场话题", shares: "66万+", heat: 85, time: "12小时前" },
  { id: 5, title: "方言版翻唱一夜上头，全网开启二创大赛", tag: "音乐出圈", category: "文娱消费", shares: "58万+", heat: 80, time: "1天前" },
  { id: 6, title: "硬核up主自制「没用发明」再出新作，评论区笑翻", tag: "创意出圈", category: "兴趣圈层", shares: "52万+", heat: 77, time: "1天前" },
  { id: 7, title: "熊猫幼崽「越狱未遂」，监控片段被网友二创疯转", tag: "萌点出圈", category: "萌宠日常", shares: "47万+", heat: 74, time: "1天前" },
  { id: 8, title: "「重启人生」挑战风靡全网，剧本杀式复盘引热议", tag: "话题复盘", category: "现象讨论", shares: "39万+", heat: 70, time: "2天前" },
];

export type CatItem = {
  id: number;
  title: string;
  summary: string;
  tag: string;
  heat: string;
};

export type CatGroup = {
  key: string;
  name: string;
  desc: string;
  accent: "primary" | "accent" | "secondary";
  items: CatItem[];
};

export const catGroups: CatGroup[] = [
  {
    key: "hotwords",
    name: "热梗速递",
    desc: "全网最热的梗从哪来、怎么传、为什么上头",
    accent: "primary",
    items: [
      { id: 1, title: "「那我问你」梗的考古：一个表情包的三次翻红", summary: "从短视频评论到游戏弹幕，一个万能句式如何完成三连传播，成为年轻人回怼的标准答案。", tag: "梗考据", heat: "38万围观" },
      { id: 2, title: "「电子奶茶」为什么成了朋友圈新宠", summary: "一句自我调侃的奶茶代餐，背后是打工人对仪式感的集体温柔。", tag: "热梗复盘", heat: "29万围观" },
      { id: 3, title: "「撤回再撤回」手速梗：聊天里的小剧场", summary: "撤回功能成了网友的喜剧舞台，一部三十秒的撤回大戏能有多少种演法？", tag: "热梗速递", heat: "24万围观" },
    ],
  },
  {
    key: "spread",
    name: "疯传现场",
    desc: "那些一夜刷屏的传播事件，我们逐环拆解",
    accent: "secondary",
    items: [
      { id: 1, title: "一场「县城咖啡热」为何能三天刷屏全网", summary: "价格、情绪与本地叙事叠加，一杯村咖如何撬动全国消费者的注意力。", tag: "传播拆解", heat: "96万围观" },
      { id: 2, title: "录音梗、流程图与故事会：一条微博的裂变路径", summary: "从一条原文到无数二创，我们把一次疯传的每个转发节点都画了出来。", tag: "事件复盘", heat: "61万围观" },
      { id: 3, title: "「善意的巧合」爆火背后，评论区为何集体破防", summary: "一条普通求助帖被陌生人接龙，一天之内长成一场全网接力。", tag: "温暖现场", heat: "45万围观" },
    ],
  },
  {
    key: "circles",
    name: "出圈合集",
    desc: "跨圈层刷屏的年度名场面一次看够",
    accent: "accent",
    items: [
      { id: 1, title: "年度破圈名场面盘点：从饭圈到游戏圈的共同语言", summary: "真正的出圈是让不相关的人也愿意停下来看三秒，这十个瞬间做到了。", tag: "年度盘点", heat: "80万围观" },
      { id: 2, title: "那些「本圈自嗨变全网狂欢」的出圈事件", summary: "小圈层文化如何突破次元壁，成为大众的快乐源泉。", tag: "出圈研究", heat: "57万围观" },
      { id: 3, title: "萌点、燃点与笑点：内容出圈的三把钥匙", summary: "我们用十组数据拆解：究竟什么样的内容最容易跨越圈层。", tag: "内容观察", heat: "33万围观" },
    ],
  },
  {
    key: "gossip",
    name: "吃瓜前线",
    desc: "全网热点的第一现场与完整时间线",
    accent: "primary",
    items: [
      { id: 1, title: "一场「赛博团建」名场面复盘，网友：看完全员代入", summary: "从预告到反转再到二创，我们把一场全民围观的故事线完整串了起来。", tag: "瓜料梳理", heat: "72万围观" },
      { id: 2, title: "「公开信」也能疯传？我们研究了传播最快的三种格式", summary: "为什么有些长文一夜间传遍全网，而有些写得再好也无人问津。", tag: "现象研究", heat: "41万围观" },
      { id: 3, title: "吃瓜礼仪课：如何理性围观一场网络闹剧", summary: "吃瓜虽好，莫忘核实来源。我们整理了一份进阶吃瓜指南。", tag: "理性吃瓜", heat: "28万围观" },
    ],
  },
];

export type FeatureItem = {
  id: number;
  category: string;
  readMinutes: number;
  date: string;
  title: string;
  excerpt: string;
  image: string;
  imageAlt: string;
};

export const featureList: FeatureItem[] = [
  {
    id: 1,
    category: "疯传拆解",
    readMinutes: 8,
    date: "2026-09-05",
    title: "一杯「村咖」如何用三天刷屏全网：县城消费热的完整传播链",
    excerpt: "从一家县城咖啡店的排队视频说起，我们还原了这场刷屏背后的情绪动机：价格反差、本地叙事与大众对「松弛感」的共同向往。转发过万不是偶然，而是内容踩中了三条大众情绪的共振点。",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20a%20crowded%20small%20county%20coffee%20shop%20with%20young%20people%20queuing%20holding%20colorful%20paper%20cups%2C%20cream%20and%20beige%20background%20with%20soft%20vermilion%20red%20and%20golden%20accents%2C%20minimal%20papercut%20style%2C%20cozy%20daily%20life%20scene%2C%20warm%20neutral%20tone%20throughout%2C%20clean%20composition%20with%20plenty%20of%20negative%20space&width=1200&height=800&seq=feature-coffee-01&orientation=landscape",
    imageAlt: "县城咖啡店排队热卖的插画",
  },
  {
    id: 2,
    category: "出圈研究",
    readMinutes: 6,
    date: "2026-09-02",
    title: "为什么越「没用」的发明越容易出圈？我们复盘了三代爆款",
    excerpt: "一本正经地做一件毫无用处的事，为何总能戳中全网笑点？我们从「反差」「仪式感」与「评论区共创」三个角度，拆解这类内容百试不爽的传播公式，并总结出可复用的出圈方法论。",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20a%20clever%20engineer%20holding%20a%20silly%20useless%20invention%20with%20gears%20and%20levers%20in%20a%20simple%20workshop%2C%20cream%20and%20sand%20background%2C%20vermilion%20red%20and%20golden%20yellow%20accent%20shapes%2C%20minimal%20papercut%20style%2C%20playful%20and%20whimsical%2C%20warm%20neutral%20tone%2C%20clean%20layout%20with%20soft%20shadows&width=1200&height=800&seq=feature-invent-02&orientation=landscape",
    imageAlt: "硬核发明家与无用发明的插画",
  },
  {
    id: 3,
    category: "年度盘点",
    readMinutes: 10,
    date: "2026-08-28",
    title: "年度破圈名场面图鉴：十个让全网停下刷手机的瞬间",
    excerpt: "真正的破圈，是让八竿子打不着的人都愿意停下来多看三秒。我们从高校、职场、县城与萌宠四条线索出发，挑出十个最具代表性的传播名场面，梳理它们共同的爆点基因。",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20collage%20of%20ten%20mini%20scenes%20representing%20viral%20internet%20moments%20including%20student%20dorm%2C%20office%20worker%2C%20county%20town%20and%20panda%2C%20arranged%20in%20a%20grid%20with%20cream%20background%2C%20vermilion%20and%20gold%20color%20accents%2C%20papercut%20style%2C%20lively%20crowd%20energy%2C%20warm%20consistent%20tone%2C%20clean%20balanced%20composition&width=1200&height=800&seq=feature-circle-03&orientation=landscape",
    imageAlt: "年度破圈名场面拼贴插画",
  },
  {
    id: 4,
    category: "热梗考据",
    readMinutes: 7,
    date: "2026-08-22",
    title: "从饭圈到游戏圈：一个「回怼句式」的三次翻红考古",
    excerpt: "一个万能句式的走红往往不止一次。我们从它最早的出处出发，梳理它在饭圈、短视频与游戏弹幕中的三次命运转折，理解梗文化如何在不同的圈层语境里反复获得新生。",
    image: "https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20illustration%20of%20chat%20bubbles%20and%20speech%20text%20floating%20over%20a%20mobile%20phone%20with%20laughing%20faces%2C%20cream%20and%20beige%20background%2C%20vermilion%20and%20golden%20bubble%20accents%2C%20minimal%20papercut%20meme%20culture%20style%2C%20youthful%20and%20fun%2C%20warm%20neutral%20tone%2C%20clean%20modern%20composition&width=1200&height=800&seq=feature-meme-04&orientation=landscape",
    imageAlt: "网络回怼句式传播插画",
  },
];

export const newsline: { time: string; title: string; text: string }[] = [
  { time: "今日 09:20", title: "村咖排队视频单日播放破亿", text: "一条两分钟的排队实录在短视频平台冲上热搜，评论区开始自发晒自家县城咖啡馆。" },
  { time: "今日 07:05", title: "宿舍爆改话题登上校园榜第一", text: "高校账号集体下场晒改造对比图，「开学季爆改」成为当季最强出圈叙事。" },
  { time: "昨日 22:40", title: "方言翻唱二创大赛开启", text: "在原始版本刷屏八小时后，各大方言区网友开启二创，播放量迅速突破千万。" },
  { time: "昨日 18:10", title: "反内卷梗图被转进职场社区", text: "职场博主大量引用该组梗图讨论加班文化，话题讨论量较前日翻了三倍。" },
];

export const statsData = [
  { value: "1,200+", label: "全网热点跟进" },
  { value: "860万+", label: "累计互动阅读" },
  { value: "12 大", label: "内容分类栏目" },
  { value: "24h", label: "重大事件响应" },
];

export type FaqItem = { q: string; a: string };

export const faqList: FaqItem[] = [
  { q: "吃瓜爆网主要盘点哪些内容？", a: "我们专注网络爆传刷屏内容，包括转发过万的出圈梗、疯狂传播的事件复盘、全网吃瓜热点速递，以及各类刷屏名场面的来源考据。栏目划分上以热梗速递、疯传现场、出圈合集与吃瓜前线四大主线为主。" },
  { q: "平台内容多久更新一次？", a: "热点速递与热榜板块每日更新，深度盘点与出圈梗合集通常每周新增数篇。遇到重大传播事件时，我们会在 24 小时内跟进完整复盘，尽量还原事件从发酵到出圈的全过程。" },
  { q: "「转发过万」的数据从哪里来？", a: "我们综合公开的社交平台热度、互动量与媒体报道进行交叉核实，标注转发与讨论量级时以公开可见数据为准，并在复盘内容里注明时间点与来源，方便读者自查。" },
  { q: "读者可以投稿或分享自己发现的爆梗吗？", a: "当然可以。若你发现有趣的刷屏内容、疯传事件或新鲜热梗，欢迎通过页面底部的订阅与留言入口告诉我们。审核通过后会进入选题库，并在合适栏目里以「读者发现」的形式呈现。" },
  { q: "面对尚未定论的热点，你们如何处理？", a: "我们坚持「先核实再复盘」的原则。对于仍在发酵、真假不明的吃瓜话题，会先做来源标注与事实核对，已反转或存疑的部分会明确提示，不让读者被断章取义的信息带偏。" },
];